/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED FROM `elasticsearch/` BY
// `yarn workspace @elastic/esql-definitions generate`.

import type { DefinitionDocs } from '../../definition_types';

import absDocs from './abs';
import absentOverTimeDocs from './absent_over_time';
import acosDocs from './acos';
import acoshDocs from './acosh';
import asinDocs from './asin';
import asinhDocs from './asinh';
import atanDocs from './atan';
import atanhDocs from './atanh';
import avgDocs from './avg';
import avgOverTimeDocs from './avg_over_time';
import bottomkDocs from './bottomk';
import ceilDocs from './ceil';
import clampDocs from './clamp';
import clampMaxDocs from './clamp_max';
import clampMinDocs from './clamp_min';
import cosDocs from './cos';
import coshDocs from './cosh';
import countDocs from './count';
import countOverTimeDocs from './count_over_time';
import dayOfMonthDocs from './day_of_month';
import dayOfWeekDocs from './day_of_week';
import dayOfYearDocs from './day_of_year';
import daysInMonthDocs from './days_in_month';
import degDocs from './deg';
import deltaDocs from './delta';
import derivDocs from './deriv';
import expDocs from './exp';
import firstOverTimeDocs from './first_over_time';
import floorDocs from './floor';
import histogramAvgDocs from './histogram_avg';
import histogramCountDocs from './histogram_count';
import histogramFractionDocs from './histogram_fraction';
import histogramQuantileDocs from './histogram_quantile';
import histogramSumDocs from './histogram_sum';
import hourDocs from './hour';
import ideltaDocs from './idelta';
import increaseDocs from './increase';
import irateDocs from './irate';
import lastOverTimeDocs from './last_over_time';
import limitkDocs from './limitk';
import lnDocs from './ln';
import log10Docs from './log10';
import log2Docs from './log2';
import maxDocs from './max';
import maxOverTimeDocs from './max_over_time';
import minDocs from './min';
import minOverTimeDocs from './min_over_time';
import minuteDocs from './minute';
import monthDocs from './month';
import piDocs from './pi';
import presentOverTimeDocs from './present_over_time';
import quantileDocs from './quantile';
import quantileOverTimeDocs from './quantile_over_time';
import radDocs from './rad';
import rateDocs from './rate';
import roundDocs from './round';
import scalarDocs from './scalar';
import sgnDocs from './sgn';
import sinDocs from './sin';
import sinhDocs from './sinh';
import sqrtDocs from './sqrt';
import stddevDocs from './stddev';
import stddevOverTimeDocs from './stddev_over_time';
import stdvarDocs from './stdvar';
import stdvarOverTimeDocs from './stdvar_over_time';
import sumDocs from './sum';
import sumOverTimeDocs from './sum_over_time';
import tanDocs from './tan';
import tanhDocs from './tanh';
import timeDocs from './time';
import timestampDocs from './timestamp';
import topkDocs from './topk';
import vectorDocs from './vector';
import yearDocs from './year';

export const promqlFunctionDocs: Record<string, DefinitionDocs> = {
  abs: absDocs,
  absent_over_time: absentOverTimeDocs,
  acos: acosDocs,
  acosh: acoshDocs,
  asin: asinDocs,
  asinh: asinhDocs,
  atan: atanDocs,
  atanh: atanhDocs,
  avg: avgDocs,
  avg_over_time: avgOverTimeDocs,
  bottomk: bottomkDocs,
  ceil: ceilDocs,
  clamp: clampDocs,
  clamp_max: clampMaxDocs,
  clamp_min: clampMinDocs,
  cos: cosDocs,
  cosh: coshDocs,
  count: countDocs,
  count_over_time: countOverTimeDocs,
  day_of_month: dayOfMonthDocs,
  day_of_week: dayOfWeekDocs,
  day_of_year: dayOfYearDocs,
  days_in_month: daysInMonthDocs,
  deg: degDocs,
  delta: deltaDocs,
  deriv: derivDocs,
  exp: expDocs,
  first_over_time: firstOverTimeDocs,
  floor: floorDocs,
  histogram_avg: histogramAvgDocs,
  histogram_count: histogramCountDocs,
  histogram_fraction: histogramFractionDocs,
  histogram_quantile: histogramQuantileDocs,
  histogram_sum: histogramSumDocs,
  hour: hourDocs,
  idelta: ideltaDocs,
  increase: increaseDocs,
  irate: irateDocs,
  last_over_time: lastOverTimeDocs,
  limitk: limitkDocs,
  ln: lnDocs,
  log10: log10Docs,
  log2: log2Docs,
  max: maxDocs,
  max_over_time: maxOverTimeDocs,
  min: minDocs,
  min_over_time: minOverTimeDocs,
  minute: minuteDocs,
  month: monthDocs,
  pi: piDocs,
  present_over_time: presentOverTimeDocs,
  quantile: quantileDocs,
  quantile_over_time: quantileOverTimeDocs,
  rad: radDocs,
  rate: rateDocs,
  round: roundDocs,
  scalar: scalarDocs,
  sgn: sgnDocs,
  sin: sinDocs,
  sinh: sinhDocs,
  sqrt: sqrtDocs,
  stddev: stddevDocs,
  stddev_over_time: stddevOverTimeDocs,
  stdvar: stdvarDocs,
  stdvar_over_time: stdvarOverTimeDocs,
  sum: sumDocs,
  sum_over_time: sumOverTimeDocs,
  tan: tanDocs,
  tanh: tanhDocs,
  time: timeDocs,
  timestamp: timestampDocs,
  topk: topkDocs,
  vector: vectorDocs,
  year: yearDocs,
};
